// Libs
import classNames from 'classnames/bind';
import { Box } from '@mui/material';
// Components, Layouts, Pages
import { ConversationItem } from '~/components/module/conversation';
// Others
import { mockDataConversations } from '~/utils/mockData/communication';
// Styles, images, icons
import styles from './ListConversation.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const ListConversation = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box component={'div'} id='listConversationComponent' className={cx('container')}>
      {Array.isArray(mockDataConversations) &&
        mockDataConversations?.length > 0 &&
        mockDataConversations?.map((conversation) => (
          <Box component={'div'} className={cx('conversationItem')}>
            <ConversationItem
              isTyping={conversation.isTyping}
              conversation={conversation}
              key={conversation?.id}
              selected={conversation?.id === '34'}
              // onClick={handleConversationClick}
            />
          </Box>
        ))}
    </Box>
  );
};

export default ListConversation;
